import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NoticiasList from '../components/NoticiasList';

export const NoticiasPage = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0F172A] to-[#1e293b] text-white py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4">
              Notícias da Semana
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Fique atualizado com as principais notícias e novidades do mundo jurídico
            </p>
          </div>
        </section>

        {/* News Grid - Agora usando dados reais do backend */}
        <NoticiasList />
      </main>
      
      <Footer />
    </div>
  );
};

export default NoticiasPage;